import Vue from "vue"
import i18n from '@/plugins/i18n';


Vue.filter("NotFoundHandel", (str: string) => {
    if (str || str.length > 0) {
        return str;
    }

    return i18n.t('general.noExternalWekalaNumber').toString();
})
